import axios from 'axios'

let uuid_service = require("uuid")
import { v4 as uuidv4 } from 'uuid'

export default class {
    urlBase = null
    payload = null
    headers = null

    constructor (urlBase) {
      this.urlBase = urlBase
    }

    exchange (pfIds, fields, no_caching) {
      let cache_id = JSON.stringify(fields).replace(/[\"]/g, '')
      let uncached_pf_ids = this.getUncachedPfIds(pfIds, cache_id)

      if(uncached_pf_ids.length > 0){
        return new Promise((resolve, reject) => {
          axios.post(`${this.urlBase}/v1/pessoa-fisica/exchange/`, {
            pf_ids: [...new Set(uncached_pf_ids)],
            options: fields
          }).then((response) => {
            let social_data = {}
            if (response.status === 200) {
              if(no_caching !== true){
                let cached_data = this.getCachedData()
                response.data.data.SocialAPI.forEach(pf => {
                  social_data[pf['pf_id']] = pf

                  if(pf['pf_id'] in cached_data === false){
                    cached_data[pf['pf_id']] = {...pf, ...{'cache_ident': cache_id}}
                  }
                })
                sessionStorage['social_data'] = JSON.stringify(cached_data)
                resolve(cached_data)
              } else {
                let exchange_data = {}
                response.data.data.SocialAPI.forEach(pf => {
                  exchange_data[pf['pf_id']] = pf
                })
                resolve(exchange_data)
              }
            }
          }).catch((error) => {
            reject(error)
          })
        })
      } else {
        return new Promise((resolve, reject) => {
          try {
            resolve(this.getCachedData())
          } catch (e) {
            reject(e)
          }
        })
      }
    }

    async insert_pf(cpf, nascimento, success, fail, always) {
      let device_info = await this.getDeviceInfo()

      axios.post(`${this.urlBase}/v3/pessoa-fisica/inserir/`, {
        'cpf': cpf.replace(/\D/g, ''),
        'nascimento': nascimento,
        'device': device_info
      }).then((response) => {
        if ([200, 201].includes(response.status) === true) {
          success && success(response.data.data.SocialAPI.pf_id)
        }
      }).catch((error) => {
        fail && fail(error)
      }).finally(() => {
        always && always()
      })
    }

    async insert_pf_sem_cpf(nome, sexo, nascimento, success, fail, always) {
      let device_info = await this.getDeviceInfo()

      axios.post(`${this.urlBase}/v1/pessoa-fisica/inserir/`, {
        'cpf': null,
        'nome': nome,
        'sexo': sexo,
        'nascimento': nascimento,
        'device': device_info
      }).then((response) => {
        if ([200, 201].includes(response.status) === true) {
          success && success(response.data.data.SocialAPI.pf_id)
        }
      }).catch((error) => {
        fail && fail(error)
      }).finally(() => {
        always && always()
      })
    }

    async getDeviceInfo() {
      return {
        'id': uuidv4().substring(0, 30),
        'log': {
          'lat': -7.98391133, //BRA HeadQuarter's location
          'lon': -34.83876744
        }
      }
    }

    getUncachedPfIds(pf_ids, cache_ident){
      let cached_data = this.getCachedData()
      let uncached_pf_ids = []
      pf_ids.forEach(pf_id => {
        if(pf_id in cached_data === false || (pf_id in cached_data && cached_data[pf_id]['cache_ident'] !== cache_ident) ){
          uncached_pf_ids.push(pf_id)
        }
      })
      return uncached_pf_ids
    }

    getCachedData() {
      try {
        return JSON.parse(sessionStorage['social_data'])
      } catch (error) {
        return {}
      }
    }

    getPfFotoUrlFromFiles(pf_files) {
      let foto_url = null
      if(pf_files['foto']['public'] && pf_files['foto']['public'].length > 0){
        foto_url = pf_files['foto']['public'][0]['foto_url']
      }

      if(pf_files['foto']['private'] && pf_files['foto']['private'].length > 0){
        foto_url = pf_files['foto']['private'][0]['foto_url']
      }

      return foto_url
    }

    setPayload (payload) {
      this.payload = payload
      return this
    }

    setHeaders (headers) {
      this.headers = headers
      return this
    }
}



// WEBPACK FOOTER //
// ./src/services/social-service.js